'use client';
"use strict";

var _excluded = ["openDelay", "closeDelay", "closeOnClick", "closeOnMouseDown", "closeOnScroll", "closeOnPointerDown", "closeOnEsc", "onOpen", "onClose", "placement", "id", "isOpen", "defaultIsOpen", "arrowSize", "arrowShadowColor", "arrowPadding", "modifiers", "isDisabled", "gutter", "offset", "direction"],
  _excluded2 = ["children", "label", "shouldWrapChildren", "aria-label", "hasArrow", "bg", "portalProps", "background", "backgroundColor", "bgColor", "motionProps"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Tooltip: function Tooltip() {
    return _Tooltip;
  },
  useTooltip: function useTooltip() {
    return _useTooltip;
  }
});
module.exports = __toCommonJS(src_exports);

// src/tooltip.tsx
var import_popper2 = require("@chakra-ui/popper");
var import_portal = require("@chakra-ui/portal");
var import_system = require("@chakra-ui/system");

// ../../utilities/object-utils/src/omit.ts
function omit(object) {
  var keysToOmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var clone = Object.assign({}, object);
  var _iterator2 = _createForOfIteratorHelper(keysToOmit),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var key = _step2.value;
      if (key in clone) {
        delete clone[key];
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return clone;
}

// ../../utilities/object-utils/src/pick.ts
function pick(object, keysToPick) {
  var result = {};
  var _iterator3 = _createForOfIteratorHelper(keysToPick),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var key = _step3.value;
      if (key in object) {
        result[key] = object[key];
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return result;
}

// src/tooltip.tsx
var import_framer_motion = require("framer-motion");
var import_react2 = require("react");

// src/tooltip.transition.tsx
var scale = {
  exit: {
    scale: 0.85,
    opacity: 0,
    transition: {
      opacity: {
        duration: 0.15,
        easings: "easeInOut"
      },
      scale: {
        duration: 0.2,
        easings: "easeInOut"
      }
    }
  },
  enter: {
    scale: 1,
    opacity: 1,
    transition: {
      opacity: {
        easings: "easeOut",
        duration: 0.2
      },
      scale: {
        duration: 0.2,
        ease: [0.175, 0.885, 0.4, 1.1]
      }
    }
  }
};

// src/use-tooltip.ts
var import_dom_utils = require("@chakra-ui/dom-utils");
var import_popper = require("@chakra-ui/popper");
var import_react_use_disclosure = require("@chakra-ui/react-use-disclosure");
var import_react_use_event_listener = require("@chakra-ui/react-use-event-listener");
var import_react_use_merge_refs = require("@chakra-ui/react-use-merge-refs");
var import_shared_utils = require("@chakra-ui/shared-utils");
var import_react = require("react");
var getDoc = function getDoc(ref) {
  var _a;
  return ((_a = ref.current) == null ? void 0 : _a.ownerDocument) || document;
};
var getWin = function getWin(ref) {
  var _a, _b;
  return ((_b = (_a = ref.current) == null ? void 0 : _a.ownerDocument) == null ? void 0 : _b.defaultView) || window;
};
function _useTooltip() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$openDelay = props.openDelay,
    openDelay = _props$openDelay === void 0 ? 0 : _props$openDelay,
    _props$closeDelay = props.closeDelay,
    closeDelay = _props$closeDelay === void 0 ? 0 : _props$closeDelay,
    _props$closeOnClick = props.closeOnClick,
    closeOnClick = _props$closeOnClick === void 0 ? true : _props$closeOnClick,
    closeOnMouseDown = props.closeOnMouseDown,
    closeOnScroll = props.closeOnScroll,
    _props$closeOnPointer = props.closeOnPointerDown,
    closeOnPointerDown = _props$closeOnPointer === void 0 ? closeOnMouseDown : _props$closeOnPointer,
    _props$closeOnEsc = props.closeOnEsc,
    closeOnEsc = _props$closeOnEsc === void 0 ? true : _props$closeOnEsc,
    onOpenProp = props.onOpen,
    onCloseProp = props.onClose,
    placement = props.placement,
    id = props.id,
    isOpenProp = props.isOpen,
    defaultIsOpen = props.defaultIsOpen,
    _props$arrowSize = props.arrowSize,
    arrowSize = _props$arrowSize === void 0 ? 10 : _props$arrowSize,
    arrowShadowColor = props.arrowShadowColor,
    arrowPadding = props.arrowPadding,
    modifiers = props.modifiers,
    isDisabled = props.isDisabled,
    gutter = props.gutter,
    offset = props.offset,
    direction = props.direction,
    htmlProps = _objectWithoutProperties(props, _excluded);
  var _ref2 = (0, import_react_use_disclosure.useDisclosure)({
      isOpen: isOpenProp,
      defaultIsOpen: defaultIsOpen,
      onOpen: onOpenProp,
      onClose: onCloseProp
    }),
    isOpen = _ref2.isOpen,
    onOpen = _ref2.onOpen,
    onClose = _ref2.onClose;
  var _ref3 = (0, import_popper.usePopper)({
      enabled: isOpen,
      placement: placement,
      arrowPadding: arrowPadding,
      modifiers: modifiers,
      gutter: gutter,
      offset: offset,
      direction: direction
    }),
    referenceRef = _ref3.referenceRef,
    getPopperProps = _ref3.getPopperProps,
    getArrowInnerProps = _ref3.getArrowInnerProps,
    getArrowProps = _ref3.getArrowProps;
  var uuid = (0, import_react.useId)();
  var uid = id != null ? id : uuid;
  var tooltipId = "tooltip-".concat(uid);
  var ref = (0, import_react.useRef)(null);
  var enterTimeout = (0, import_react.useRef)();
  var clearEnterTimeout = (0, import_react.useCallback)(function () {
    if (enterTimeout.current) {
      clearTimeout(enterTimeout.current);
      enterTimeout.current = void 0;
    }
  }, []);
  var exitTimeout = (0, import_react.useRef)();
  var clearExitTimeout = (0, import_react.useCallback)(function () {
    if (exitTimeout.current) {
      clearTimeout(exitTimeout.current);
      exitTimeout.current = void 0;
    }
  }, []);
  var closeNow = (0, import_react.useCallback)(function () {
    clearExitTimeout();
    onClose();
  }, [onClose, clearExitTimeout]);
  var dispatchCloseEvent = useCloseEvent(ref, closeNow);
  var openWithDelay = (0, import_react.useCallback)(function () {
    if (!isDisabled && !enterTimeout.current) {
      if (isOpen) dispatchCloseEvent();
      var win = getWin(ref);
      enterTimeout.current = win.setTimeout(onOpen, openDelay);
    }
  }, [dispatchCloseEvent, isDisabled, isOpen, onOpen, openDelay]);
  var closeWithDelay = (0, import_react.useCallback)(function () {
    clearEnterTimeout();
    var win = getWin(ref);
    exitTimeout.current = win.setTimeout(closeNow, closeDelay);
  }, [closeDelay, closeNow, clearEnterTimeout]);
  var onClick = (0, import_react.useCallback)(function () {
    if (isOpen && closeOnClick) {
      closeWithDelay();
    }
  }, [closeOnClick, closeWithDelay, isOpen]);
  var onPointerDown = (0, import_react.useCallback)(function () {
    if (isOpen && closeOnPointerDown) {
      closeWithDelay();
    }
  }, [closeOnPointerDown, closeWithDelay, isOpen]);
  var onKeyDown = (0, import_react.useCallback)(function (event) {
    if (isOpen && event.key === "Escape") {
      closeWithDelay();
    }
  }, [isOpen, closeWithDelay]);
  (0, import_react_use_event_listener.useEventListener)(function () {
    return getDoc(ref);
  }, "keydown", closeOnEsc ? onKeyDown : void 0);
  (0, import_react_use_event_listener.useEventListener)(function () {
    if (!closeOnScroll) return null;
    var node = ref.current;
    if (!node) return null;
    var scrollParent = (0, import_dom_utils.getScrollParent)(node);
    return scrollParent.localName === "body" ? getWin(ref) : scrollParent;
  }, "scroll", function () {
    if (isOpen && closeOnScroll) {
      closeNow();
    }
  }, {
    passive: true,
    capture: true
  });
  (0, import_react.useEffect)(function () {
    if (!isDisabled) return;
    clearEnterTimeout();
    if (isOpen) onClose();
  }, [isDisabled, isOpen, onClose, clearEnterTimeout]);
  (0, import_react.useEffect)(function () {
    return function () {
      clearEnterTimeout();
      clearExitTimeout();
    };
  }, [clearEnterTimeout, clearExitTimeout]);
  (0, import_react_use_event_listener.useEventListener)(function () {
    return ref.current;
  }, "pointerleave", closeWithDelay);
  var getTriggerProps = (0, import_react.useCallback)(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var triggerProps = _objectSpread(_objectSpread({}, props2), {}, {
      ref: (0, import_react_use_merge_refs.mergeRefs)(ref, _ref, referenceRef),
      onPointerEnter: (0, import_shared_utils.callAllHandlers)(props2.onPointerEnter, function (e) {
        if (e.pointerType === "touch") return;
        openWithDelay();
      }),
      onClick: (0, import_shared_utils.callAllHandlers)(props2.onClick, onClick),
      onPointerDown: (0, import_shared_utils.callAllHandlers)(props2.onPointerDown, onPointerDown),
      onFocus: (0, import_shared_utils.callAllHandlers)(props2.onFocus, openWithDelay),
      onBlur: (0, import_shared_utils.callAllHandlers)(props2.onBlur, closeWithDelay),
      "aria-describedby": isOpen ? tooltipId : void 0
    });
    return triggerProps;
  }, [openWithDelay, closeWithDelay, onPointerDown, isOpen, tooltipId, onClick, referenceRef]);
  var getTooltipPositionerProps = (0, import_react.useCallback)(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var forwardedRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return getPopperProps(_objectSpread(_objectSpread({}, props2), {}, {
      style: _objectSpread(_objectSpread({}, props2.style), {}, _defineProperty(_defineProperty({}, import_popper.popperCSSVars.arrowSize["var"], arrowSize ? "".concat(arrowSize, "px") : void 0), import_popper.popperCSSVars.arrowShadowColor["var"], arrowShadowColor))
    }), forwardedRef);
  }, [getPopperProps, arrowSize, arrowShadowColor]);
  var getTooltipProps = (0, import_react.useCallback)(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var styles = _objectSpread(_objectSpread({}, props2.style), {}, {
      position: "relative",
      transformOrigin: import_popper.popperCSSVars.transformOrigin.varRef
    });
    return _objectSpread(_objectSpread(_objectSpread({
      ref: ref2
    }, htmlProps), props2), {}, {
      id: tooltipId,
      role: "tooltip",
      style: styles
    });
  }, [htmlProps, tooltipId]);
  return {
    isOpen: isOpen,
    show: openWithDelay,
    hide: closeWithDelay,
    getTriggerProps: getTriggerProps,
    getTooltipProps: getTooltipProps,
    getTooltipPositionerProps: getTooltipPositionerProps,
    getArrowProps: getArrowProps,
    getArrowInnerProps: getArrowInnerProps
  };
}
var closeEventName = "chakra-ui:close-tooltip";
function useCloseEvent(ref, close) {
  (0, import_react.useEffect)(function () {
    var doc = getDoc(ref);
    doc.addEventListener(closeEventName, close);
    return function () {
      return doc.removeEventListener(closeEventName, close);
    };
  }, [close, ref]);
  return function () {
    var doc = getDoc(ref);
    var win = getWin(ref);
    doc.dispatchEvent(new win.CustomEvent(closeEventName));
  };
}

// src/tooltip.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var MotionDiv = (0, import_system.chakra)(import_framer_motion.motion.div);
var _Tooltip = (0, import_system.forwardRef)(function (props, ref) {
  var _a, _b;
  var styles = (0, import_system.useStyleConfig)("Tooltip", props);
  var ownProps = (0, import_system.omitThemingProps)(props);
  var theme = (0, import_system.useTheme)();
  var children = ownProps.children,
    label = ownProps.label,
    shouldWrapChildren = ownProps.shouldWrapChildren,
    ariaLabel = ownProps["aria-label"],
    hasArrow = ownProps.hasArrow,
    bg = ownProps.bg,
    portalProps = ownProps.portalProps,
    background = ownProps.background,
    backgroundColor = ownProps.backgroundColor,
    bgColor = ownProps.bgColor,
    motionProps = ownProps.motionProps,
    rest = _objectWithoutProperties(ownProps, _excluded2);
  var userDefinedBg = (_b = (_a = background != null ? background : backgroundColor) != null ? _a : bg) != null ? _b : bgColor;
  if (userDefinedBg) {
    styles.bg = userDefinedBg;
    var bgVar = (0, import_system.getCSSVar)(theme, "colors", userDefinedBg);
    styles[import_popper2.popperCSSVars.arrowBg["var"]] = bgVar;
  }
  var tooltip = _useTooltip(_objectSpread(_objectSpread({}, rest), {}, {
    direction: theme.direction
  }));
  var shouldWrap = typeof children === "string" || shouldWrapChildren;
  var trigger;
  if (shouldWrap) {
    trigger = /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_system.chakra.span, _objectSpread(_objectSpread({
      display: "inline-block",
      tabIndex: 0
    }, tooltip.getTriggerProps()), {}, {
      children: children
    }));
  } else {
    var child = import_react2.Children.only(children);
    trigger = (0, import_react2.cloneElement)(child, tooltip.getTriggerProps(child.props, child.ref));
  }
  var hasAriaLabel = !!ariaLabel;
  var _tooltipProps = tooltip.getTooltipProps({}, ref);
  var tooltipProps = hasAriaLabel ? omit(_tooltipProps, ["role", "id"]) : _tooltipProps;
  var srOnlyProps = pick(_tooltipProps, ["role", "id"]);
  if (!label) {
    return /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
      children: children
    });
  }
  return /* @__PURE__ */(0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
    children: [trigger, /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_framer_motion.AnimatePresence, {
      children: tooltip.isOpen && /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_portal.Portal, _objectSpread(_objectSpread({}, portalProps), {}, {
        children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_system.chakra.div, _objectSpread(_objectSpread({}, tooltip.getTooltipPositionerProps()), {}, {
          __css: {
            zIndex: styles.zIndex,
            pointerEvents: "none"
          },
          children: /* @__PURE__ */(0, import_jsx_runtime.jsxs)(MotionDiv, _objectSpread(_objectSpread(_objectSpread({
            variants: scale,
            initial: "exit",
            animate: "enter",
            exit: "exit"
          }, motionProps), tooltipProps), {}, {
            __css: styles,
            children: [label, hasAriaLabel && /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_system.chakra.span, _objectSpread(_objectSpread({
              srOnly: true
            }, srOnlyProps), {}, {
              children: ariaLabel
            })), hasArrow && /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_system.chakra.div, {
              "data-popper-arrow": true,
              className: "chakra-tooltip__arrow-wrapper",
              children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_system.chakra.div, {
                "data-popper-arrow-inner": true,
                className: "chakra-tooltip__arrow",
                __css: {
                  bg: styles.bg
                }
              })
            })]
          }))
        }))
      }))
    })]
  });
});
_Tooltip.displayName = "Tooltip";
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Tooltip: _Tooltip,
  useTooltip: _useTooltip
});